import { Score } from './types';

const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '' // Same origin in production
  : 'http://localhost:5000'; // Development server

// Get scores from server
export const getScores = async (): Promise<Score[]> => {
  try {
    console.log('Fetching scores from server...');
    const response = await fetch(`${API_BASE_URL}/get-scores`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const scores: Score[] = await response.json();
    console.log('Fetched scores from server:', scores);
    return scores;
  } catch (error) {
    console.error('Failed to fetch scores from server:', error);
    // Fallback to localStorage for backward compatibility
    try {
      const storedScores = localStorage.getItem('minesweeper-scores');
      if (storedScores) {
        console.log('Falling back to localStorage scores');
        return JSON.parse(storedScores);
      }
    } catch (localError) {
      console.error('localStorage fallback also failed:', localError);
    }
    return [];
  }
};

// Save score to server
export const postScore = async (name: string, score: number): Promise<boolean> => {
  try {
    console.log('Posting score to server:', { name, score });
    
    const response = await fetch(`${API_BASE_URL}/post-score`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: name.trim() || 'Anonymous',
        score: score
      })
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }
    
    const result = await response.json();
    console.log('Score posted successfully:', result);
    return true;
  } catch (error) {
    console.error('Failed to post score to server:', error);
    // Fallback to localStorage for backward compatibility
    try {
      console.log('Falling back to localStorage for score saving');
      const currentScores = JSON.parse(localStorage.getItem('minesweeper-scores') || '[]');
      const newScore = {
        name: name.trim() || 'Anonymous',
        score,
        date: new Date().toISOString(),
      };
      
      const updatedScores = [...currentScores, newScore]
        .sort((a, b) => a.score - b.score)
        .slice(0, 10);
      
      localStorage.setItem('minesweeper-scores', JSON.stringify(updatedScores));
      return true;
    } catch (localError) {
      console.error('localStorage fallback also failed:', localError);
      return false;
    }
  }
};
